export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN' // access_token
export const SET_APP_INFO = 'SET_APP_INFO'
